/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// PDP: on mobile, move the "Specs & Dimensions" card below the buy box.
// On desktop it stays in the gallery (left) column.
(function () {
  function placeSpecs() {
    var pdp = document.querySelector('.pdp');
    if (!pdp) return;
    var card = pdp.querySelector('.pdp__specs-card');
    if (!card) return;
    var gallery = pdp.querySelector('.pdp__gallery');
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile) {
      // Append to the grid so it renders after the buy box (.pdp__info).
      if (card.parentElement !== pdp || pdp.lastElementChild !== card) {
        pdp.appendChild(card);
      }
    } else if (gallery && card.parentElement !== gallery) {
      gallery.appendChild(card);
    }
  }
  if (document.readyState !== 'loading') placeSpecs();
  else document.addEventListener('DOMContentLoaded', placeSpecs);
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(placeSpecs, 150);
  });
})();

// PDP gallery thumbnails: on mobile, make the strip a smooth, swipeable rail
// with edge-fade cues so it's obvious there are more images to the right.
(function () {
  var css = ''
    + '@media (max-width: 749px){'
    + '  .hf-board .hf-thumbs{ position: relative; }'
    + '  .hf-board .hf-thumbs__arrow{ display: none !important; }'
    + '  .hf-board .hf-thumbs__track{ overflow-x: auto; -webkit-overflow-scrolling: touch; scroll-snap-type: x proximity; padding-right: 42px; }'
    + '  .hf-board .hf-thumb{ scroll-snap-align: start; }'
    + '  .hf-board .hf-thumbs::before, .hf-board .hf-thumbs::after{ content:""; position:absolute; top:0; bottom:0; width:54px; pointer-events:none; z-index:5; opacity:0; transition:opacity .18s ease; }'
    + '  .hf-board .hf-thumbs::after{ right:0; background:linear-gradient(to right, rgba(255,255,255,0), #ffffff 76%); }'
    + '  .hf-board .hf-thumbs::before{ left:0; background:linear-gradient(to left, rgba(255,255,255,0), #ffffff 76%); }'
    + '  .hf-board .hf-thumbs.is-scroll-right::after{ opacity:1; }'
    + '  .hf-board .hf-thumbs.is-scroll-left::before{ opacity:1; }'
    + '}';
  var s = document.createElement('style');
  s.setAttribute('data-hf-thumb-cues', '');
  s.textContent = css;
  document.head.appendChild(s);

  function initThumbCues() {
    var tracks = document.querySelectorAll('.hf-thumbs__track');
    Array.prototype.forEach.call(tracks, function (track) {
      if (track.__hfCued) return;
      track.__hfCued = true;
      var wrap = track.closest ? track.closest('.hf-thumbs') : track.parentElement;
      if (!wrap) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        wrap.classList.toggle('is-scroll-left', track.scrollLeft > 4);
        wrap.classList.toggle('is-scroll-right', track.scrollLeft < max - 4);
      }
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      setTimeout(update, 300);
      setTimeout(update, 1200);
    });
  }
  if (document.readyState !== 'loading') initThumbCues();
  else document.addEventListener('DOMContentLoaded', initThumbCues);
})();
